/*
 * Die Anwendertexte der historischen Vorgänge (Spec „Historische Vorgänge anlegen und anzeigen“, Aufgabe 26; Hausregel
 * „Texte in Properties“): Schlüssel englisch, Werte deutsch. Das Kennzeichen „historisch“ ist dasselbe Wort wie an den
 * Kacheln der Kundenübersicht (`MARKER_TEXT.HISTORICAL`, W33) — einmal geschrieben.
 */
import { MARKER_TEXT } from "../../views/customerOverview/texts.js";

/** Die Arten eines historischen Vorgangs im Web. */
export type HistoricalKind = "offer" | "order";

/**
 * Der erste Ordner der Ablage je Belegart: Spiegel von ABLAGE_VORLAGE (Domäne); web importiert domain nie (W26). Ein Test
 * liest die Domänenquelle und hält beide gleich.
 */
export const STORAGE_TEMPLATE: Readonly<Record<"OFFER" | "SALES_ORDER", string>> = {
  OFFER: "Angebote",
  SALES_ORDER: "Aufträge",
};

/** Die Werte des Bereichsfilters „Art“ — dieselben Namen wie der Suchparameter `kind` des Klienten. */
export const KIND_FILTER_VALUES = ["ALL", "REAL", "HISTORICAL"] as const;
export type KindFilter = (typeof KIND_FILTER_VALUES)[number];

const KIND_FILTER = "Art";

export const HISTORICAL_TEXT = {
  // --- Kennzeichen ---
  chip: MARKER_TEXT.HISTORICAL,
  /** Das Sofort-Popup am Kennzeichen. */
  popup: "Altbestand ohne Positionen und ohne Beleg; die Nummer stammt aus dem Vorsystem.",

  // --- Knöpfe der Listen (zugleich Titel des Panels beim Erfassen) ---
  create: { offer: "Historisches Angebot erfassen", order: "Historischen Auftrag erfassen" } as Readonly<
    Record<HistoricalKind, string>>,
  /** Titel des Panels beim Bearbeiten. */
  editTitle: (kind: HistoricalKind, number: string): string =>
    (kind === "offer" ? `Historisches Angebot ${number} bearbeiten` : `Historischen Auftrag ${number} bearbeiten`),
  save: "Erfassen",
  saveEdit: "Speichern",
  edit: "Bearbeiten",
  /** Zugänglicher Name von „Bearbeiten“ am Detail. */
  editName: (title: string): string => `${title} bearbeiten`,

  // --- Felder ---
  company: "Unternehmen",
  title: "Titel",
  legacyNumber: "Alte Nummer",
  date: "Datum",
  netAmount: "Nettobetrag",
  currencyUnit: "€",
  status: "Status",
  contact: "Ansprechpartner",
  responsible: "Verantwortlich",
  note: "Notiz",
  sourceOffer: "Herkunftsangebot",
  choose: "Bitte wählen …",
  /** Der Befund an einem Pflichtfeld ohne Wahl (Unternehmen, Status) — nicht der Platzhalter der Auswahl. */
  required: "Bitte auswählen.",
  noContact: "— keiner —",
  noUser: "— niemand —",
  noOffer: "— keines —",
  amountInvalid: "Bitte einen Betrag angeben, etwa 1250,00.",
  saveFailed: "Der Vorgang konnte nicht gespeichert werden.",

  // --- Dateien ---
  filesField: "Dateien",
  /** Solange Datum oder alte Nummer fehlen, gibt es noch keinen Ablageort. */
  storagePending: "Die Ablage ergibt sich aus Datum und alter Nummer.",
  retry: "Erneut versuchen",
  done: "Fertig",
  /** Der Vorgang steht, einzelne Dateien nicht (oder sie liegen schon in der Ablage). */
  savedWithOpenFiles: "Der Vorgang ist gespeichert. Nicht jede Datei ist abgelegt — siehe die Liste.",

  // --- Bereichsfilter „Art“ ---
  kindFilter: KIND_FILTER,
  kind: { ALL: "alle", REAL: "ohne historische", HISTORICAL: "nur historische" } as Readonly<Record<KindFilter, string>>,
  /** Die Option in der kompakten Auswahl (die Beschriftung hört nur die Vorlesestimme): „Art: alle“. */
  kindOption: (value: string): string => `${KIND_FILTER}: ${value}`,
} as const;
